import PropTypes from 'prop-types';
import GranteeForm from '../GranteeForm/GranteeForm.jsx';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import DeleteBeneficiaryModal from '../DeleteBeneficiaryModal.jsx';

const GranteesForm = ({
  regimeObligatoire,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  professionalSituations,
  fields,
  selectedTab,
  handleRemoveGrantee,
  displayDeletionModal,
  setDisplayDeletionModal,
  deletingGrantee,
  setDeletingGrantee,
  isDisabledAddingChild,
  isDisabledAddingSpouse
}) => {
  return (
    <div className="w-full">
      {mapIndexed(
        (field, index) => (
          <div key={field.id}>
            <GranteeForm
              field={field}
              index={index}
              regimeObligatoire={regimeObligatoire}
              selectedTab={selectedTab}
              displayDeletionModal={displayDeletionModal}
              setDisplayDeletionModal={setDisplayDeletionModal}
              deletingGrantee={deletingGrantee}
              setDeletingGrantee={setDeletingGrantee}
              isDisabledAddingChild={isDisabledAddingChild}
              isDisabledAddingSpouse={isDisabledAddingSpouse}
              professionalSituations={professionalSituations}
              getMiddleText={getMiddleText}
              getMiddleBoolean={getMiddleBoolean}
              getMiddleNumber={getMiddleNumber}
            />
          </div>
        ),
        fields
      )}
      <DeleteBeneficiaryModal
        isDisplayed={displayDeletionModal}
        deletionMessage={getMiddleText('BENEFICIAIRE_LABEL_SUPPRESSION_MESSAGE')}
        setDisplayDeletionModal={setDisplayDeletionModal}
        handleRemoveGrantee={handleRemoveGrantee}
        setDeletingGrantee={setDeletingGrantee}
      />
    </div>
  );
};

GranteesForm.propTypes = {
  regimeObligatoire: PropTypes.object,
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  getMiddleNumber: PropTypes.func,
  fields: PropTypes.array,
  selectedTab: PropTypes.number,
  handleRemoveGrantee: PropTypes.func,
  displayDeletionModal: PropTypes.bool,
  setDisplayDeletionModal: PropTypes.func,
  isDisabledAddingChild: PropTypes.func,
  isDisabledAddingSpouse: PropTypes.func
};

export default GranteesForm;
